import React from "react";

import Header from "../components/Header";
import Footer from "../components/Footer";

export default function Contact() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="mx-auto max-w-3xl px-4 py-16 flex-grow">
        <h1 className="text-3xl font-bold text-slate-900 mb-4">Contact GymPlix</h1>
        
        <div className="space-y-4 text-slate-700">
          <p><strong>GymPlix</strong></p>
          <p>Operated by Creative Brains LTD</p>
          <p>
            For support inquiries, please contact us at:{" "}
            <a 
              href="mailto:support@gymplix.com" 
              className="text-blue-600 hover:underline"
            >
              support@gymplix.com
            </a>
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
